import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { useModal } from "../../hooks/useModal";
import { getBillingsNewBillingBlockReason } from "../../selectors/billings";
import { Icon, IconNameEnum, IconTypeEnum } from "../Icon";
import { NewBillingModal } from "../NewBillingModal";
import { Tooltip } from "../Tooltip";

import styles from "./AddBillingPeriod.module.scss";

export const AddBillingPeriod = () => {
  const { t } = useTranslation();
  const { isModalVisible, toggleModalVisibility } = useModal();

  const blockingReason = useSelector(getBillingsNewBillingBlockReason);

  const AddButton = (
    <button className={styles.button} onClick={toggleModalVisibility} disabled={!!blockingReason}>
      <Icon name={IconNameEnum.plus} type={blockingReason ? IconTypeEnum.grey : IconTypeEnum.green} />
      {t("addBillingPeriod.newPeriod")}
    </button>
  );

  return (
    <>
      {blockingReason ? (
        <Tooltip bgColor="none" content={t(`billingBlockingReason.${blockingReason}`)}>
          {AddButton}
        </Tooltip>
      ) : (
        AddButton
      )}
      <NewBillingModal isModalVisible={isModalVisible} toggleModalVisibility={toggleModalVisibility} />
    </>
  );
};
